import { defineComponent, ref, watch } from '@vue/composition-api';
import Popper from 'vue-popperjs';
import { isEqual } from 'lodash';
import ToggleCheckbox from 'components/widgets/ToggleCheckbox.vue';
const DashboardSelection = defineComponent({
    components: {
        Popper,
        ToggleCheckbox,
    },
    props: {
        dashboardList: { type: Array, required: true },
        canAddToDashboard: { type: Boolean, required: true },
        dashboardIds: { type: Array, required: true },
    },
    setup(props, { emit }) {
        const selectedDashboards = ref(props.dashboardIds ?? []);
        watch(() => props.dashboardIds, (newVal, oldVal) => {
            if (isEqual(newVal, oldVal))
                return;
            selectedDashboards.value = newVal;
        });
        watch(selectedDashboards, (newVal, oldVal) => {
            if (isEqual(newVal, oldVal))
                return;
            emit('update', selectedDashboards.value);
        });
        const selectAllDashboards = (selected) => {
            const value = selected ? props.dashboardList.map(dashboard => dashboard.id) : [];
            selectedDashboards.value = value;
        };
        const toggleDashboard = (id) => {
            const index = selectedDashboards.value.indexOf(id);
            if (index === -1) {
                selectedDashboards.value = [...selectedDashboards.value, id];
            }
            else {
                selectedDashboards.value = selectedDashboards.value.filter(dashboardId => dashboardId !== id);
            }
        };
        return {
            selectAllDashboards,
            selectedDashboards,
            toggleDashboard,
        };
    },
});
export default DashboardSelection;
